import { createSignal, createContext, useContext, type ParentComponent, Show, onMount } from "solid-js"
import { type LoginResponse, getCurrentUser, logout as apiLogout } from "./api"
import { Login } from "../components/Login"

interface AuthContextValue {
  user: () => LoginResponse["user"] | null
  refetchUser: () => void
  logout: () => void
}

const AuthContext = createContext<AuthContextValue>()

export const AuthProvider: ParentComponent = (props) => {
  const [user, setUser] = createSignal<LoginResponse["user"] | null>(null)

  const refetchUser = () => {
    setUser(getCurrentUser())
  }

  const logout = () => {
    apiLogout()
    setUser(null)
  }

  onMount(() => {
    refetchUser()
  })

  return (
    <AuthContext.Provider value={{ user, refetchUser, logout }}>
      <Show when={user() !== null} fallback={<Login onLogin={refetchUser} />}>
        {props.children}
      </Show>
    </AuthContext.Provider>
  )
}

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) throw new Error("useAuth must be used within AuthProvider")
  return context
}
